import { MutableRefObject, useState } from 'react';
import { percentageOptions, StyledSelect } from 'components/TableCells/RefundCell';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';

type CreditPercentCellProps = {
    percent: number;
    disabled?: boolean;
    onChange: (value: number) => void;
    rowIndex: number;
    colIndex: number;
    cellRefPrefix: string;
    // cellInputRefs?: MutableRefObject<{
    //     [key: string]: HTMLInputElement | HTMLSelectElement | HTMLButtonElement | HTMLDivElement | null;
    // }>;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown?: (e: any, itemId: any, rowIndex: any, colIndex: any) => void;
    itemId: number | string;
};

const CreditPercentCell = ({
    percent,
    disabled = false,
    onChange,
    rowIndex,
    colIndex,
    cellRefPrefix,
    cellInputRefs,
    handleArrowKeyDown,
    itemId,
}: CreditPercentCellProps) => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <StyledSelect
            ref={(el: any) => {
                if (cellInputRefs) {
                    cellInputRefs.current[`${cellRefPrefix}${rowIndex}-${colIndex}`] = el;
                }
            }}
            isDisabled={disabled}
            menuIsOpen={menuOpen}
            onMenuOpen={() => setMenuOpen(true)}
            onMenuClose={() => setMenuOpen(false)}
            value={percentageOptions.find((opt) => opt.value === percent) ?? percentageOptions[4]}
            onChange={(selectedOption) => {
                const { value } = selectedOption as { value: number; label: string };
                onChange(value ?? 1.0);
                setMenuOpen(false);
            }}
            options={percentageOptions}
            menuPortalTarget={document.body}
            tabIndex={-1}
            onKeyDown={(e: any) => {
                if ((e.key === 'Enter' || e.key === ' ') && !menuOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(true);
                    return;
                }
                if (e.key === 'Escape' && menuOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(false);
                    return;
                }
                if (!menuOpen) {
                    handleArrowKeyDown?.(e, itemId, rowIndex, colIndex);
                }
            }}
        />
    );
};

export default CreditPercentCell;
